<template>
  <div :class="classes" class="container">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    gutter: {
      type: Boolean,
      required: false,
      default: true
    },
    size: {
      type: String,
      required: false,
      default: 'lg',
      validator: value => ['sm', 'md', 'lg', 'xl'].includes(value)
    }
  },
  computed: {
    classes() {
      const classes = [`container--${this.size}`];

      if (this.gutter) {
        classes.push('container--gutter');
      }

      return classes;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin-inline: auto;
  width: 100%;

  &--gutter {
    padding-inline: spacing('md');

    @include breakpoint(md) {
      padding-inline: spacing('xl');
    }
  }

  &--sm {
    max-width: map-get($breakpoints, sm);
  }

  &--md {
    max-width: map-get($breakpoints, md);
  }

  &--lg {
    max-width: map-get($breakpoints, lg);
  }

  &--xl {
    max-width: map-get($breakpoints, xl);
  }
}
</style>
